import React from 'react';
import { useIntl } from 'react-intl';
import { Paper, Typography, Fab, Tooltip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import { CenteredFlexBox, FlexBox } from '../FlexBox';
import '../../Styles/dangerCircle.scss';
import Chip from '../Chip';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../Router/routes';
import { useSetAtom } from 'jotai';
import { selectedCustomerIdAtom } from '../../Atoms';
import { compareDates } from '../../Helpers/dates';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

const PrioritiesAlert = function PrioritiesAlert({ priorities = [] }) {
  const intl = useIntl();
  const navigate = useNavigate();

  const expiredPrioritiesCount = priorities.filter(({ activityDateTime }) =>
    compareDates(new Date(activityDateTime), new Date(), 'smaller')
  ).length;
  const futurePrioritiesCount = priorities.filter(({ activityDateTime }) =>
    compareDates(new Date(activityDateTime), new Date(), 'bigger')
  ).length;

  const setSelectedCustomerId = useSetAtom(selectedCustomerIdAtom);
  return (
    <FlexBox flexGrow={1} justifyContent="flex-start">
      <Paper sx={{ minWidth: '220px', borderRadius: '50px' }}>
        <Fab
          onClick={() => {
            navigate(APP_ROUTES.PRIORITIES);
            setSelectedCustomerId(null);
          }}
          variant="extended"
          sx={{
            boxShadow: 'none',
            background: 'transparent',
            color: 'inherit',
            textTransform: 'none',
            width: '100%',
            padding: '8px',
            '&:hover': {
              background: 'transparent',
            },
          }}
        >
          <CenteredFlexBox
            gap="8px"
            justifyContent={
              priorities.length === 0 ? 'flex-start' : 'space-between'
            }
            width="100%"
          >
            {priorities.length === 0 ? (
              <Tooltip
                title={intl.messages.NO_PRIORITIES}
                slotProps={{
                  tooltip: { sx: { fontSize: '1rem', padding: '8px' } },
                }}
                arrow
              >
                <CheckCircleRoundedIcon
                  color="success"
                  sx={{ fontSize: '30px', verticalAlign: 'middle' }}
                />
              </Tooltip>
            ) : (
              <CircleIcon
                className={expiredPrioritiesCount > 0 ? 'blink' : ''}
                sx={{
                  color: expiredPrioritiesCount ? '#e10b01' : '#fca600',
                  filter: expiredPrioritiesCount
                    ? 'drop-shadow(0 0 4px #f00)'
                    : 'none',
                  fontSize: '30px',
                  verticalAlign: 'middle',
                }}
              />
            )}
            <Typography variant="h6" fontSize="18px" flexGrow={1}>
              {intl.messages.PRIORITIES}
            </Typography>

            {futurePrioritiesCount > 0 && (
              <Tooltip
                title={intl.messages.FUTURE_PRIORITIES}
                slotProps={{
                  tooltip: { sx: { fontSize: '1rem', padding: '8px' } },
                }}
                arrow
              >
                <div>
                  <Chip
                    id="priorities-chip"
                    variant="contained"
                    color="#fca600"
                    height="unset"
                    label={futurePrioritiesCount}
                    fontSize="18px"
                    labelColor="#000"
                  />
                </div>
              </Tooltip>
            )}
            {expiredPrioritiesCount > 0 && (
              <Tooltip
                title={intl.messages.EXPIRED_PRIORITIES}
                slotProps={{
                  tooltip: { sx: { fontSize: '1rem', padding: '8px' } },
                }}
                arrow
              >
                <div>
                  <Chip
                    id="priorities-chip"
                    variant="contained"
                    color="#e10b01"
                    height="unset"
                    label={expiredPrioritiesCount}
                    fontSize="18px"
                    labelColor="#000"
                  />
                </div>
              </Tooltip>
            )}
          </CenteredFlexBox>
        </Fab>
      </Paper>
    </FlexBox>
  );
};

export default PrioritiesAlert;
